import { createContext, useState, useEffect } from "react";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Token cookie'si httpOnly olduğu için JS'ten okunamaz; login yanıtında
    // gelen token localStorage'da tutulur ve açılışta profil ile doğrulanır.
    const validateSession = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(
          `https://app.vivasmartcare.com/api/profile/${token}`
        );
        if (response.ok) {
          const profile = await response.json();
          setUser(profile);
          setIsAuthenticated(true);
          localStorage.setItem("user", JSON.stringify(profile));
        } else {
          // Oturum geçersiz/süresi dolmuş
          localStorage.removeItem("token");
          localStorage.removeItem("user");
        }
      } catch (error) {
        // Ağ hatasında kayıtlı kullanıcı bilgisiyle devam et
        console.error("Oturum doğrulanırken bir hata oluştu:", error);
        const savedUser = localStorage.getItem("user");
        if (savedUser) {
          try {
            setUser(JSON.parse(savedUser));
            setIsAuthenticated(true);
          } catch (parseError) {
            console.error("Error parsing user data:", parseError);
          }
        }
      } finally {
        setLoading(false);
      }
    };

    validateSession();
  }, []);

  const login = (userData, token) => {
    setUser(userData);
    setIsAuthenticated(true);
    localStorage.setItem("user", JSON.stringify(userData));
    if (token) {
      localStorage.setItem("token", token);
    }
  };

  const logout = async () => {
    try {
      // httpOnly cookie yalnızca backend tarafından temizlenebilir
      await fetch("https://app.vivasmartcare.com/api/logout", {
        method: "POST",
      });
    } catch (error) {
      console.error("Çıkış isteği sırasında bir hata oluştu:", error);
    }
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setUser(null);
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        user,
        login,
        logout,
        loading,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export { AuthContext, AuthProvider };
